import { GridColDef } from "@mui/x-data-grid";
import React from "react";
import { formatDate } from "../../helper/DateFormat";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";
import { SupportTableAIInsightsPanel } from "./SupportTableAIInsightsPanel";

const SupportTable = (props: any) => {
  const showNoData = () => {
    const rootStyle = {
      alignItems: "center",
      display: "flex",
      fontSize: 18,
      fontWeight: 600,
      justifyContent: "center",
      padding: 200
    };
    return <div style={rootStyle}>{`Support details are not available for ${props.tenantName} .`} </div>;
  };

  const columns: GridColDef[] = [
    {
      disableColumnMenu: true,
      field: "caseUri",
      filterable: false,
      headerName: "AI Summary",
      sortable: false,
      width: 100,
      renderCell: (params) => (
        <SupportTableAIInsightsPanel
          caseNumber={params.row.caseNumber}
          serviceRequestNumber={params.row.serviceRequestNumber}
        />
      )
    },
    {
      headerName: "Request Number",
      field: "serviceRequestNumber",
      width: 180,
      sortable: true,
      renderCell: (params) => (
        <a
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            cursor: "pointer"
          }}
          href={params.row.caseUri}
          target="_blank"
          rel="noopener noreferrer"
          title={params.row.caseUri}
          tabIndex={params.row.caseUri}
        >
          {params.row.serviceRequestNumber}
        </a>
      )
    },
    {
      headerName: "Title",
      field: "title",
      width: 400,
      sortable: true
    },
    {
      headerName: "Product Name",
      field: "productName",
      width: 160,
      sortable: true
    },
    {
      headerName: "Created Time",
      type: "date",
      field: "createdTime",
      width: 120,
      sortable: true,
      valueGetter: (value, row) => new Date(row.createdTime),
      renderCell: (params) => formatDate(params.row.createdTime)
    },
    {
      headerName: "Closed Time",
      type: "date",
      field: "closedDateTime",
      width: 120,
      sortable: true,
      valueGetter: (vaue, row) => new Date(row.closedDateTime),
      renderCell: (params) => formatDate(params.row.closedDateTime)
    },
    {
      headerName: "Service Request State",
      field: "serviceRequestState",
      width: 170,
      sortable: true
    },
    {
      headerName: "Case Age (In Days)",
      field: "caseAge",
      type: "number",
      width: 150,
      sortable: true
    },
    {
      headerName: "CSAT",
      type: "number",
      field: "csat",
      width: 80,
      sortable: true,
      valueGetter: (value, row) => row.csat
    },
    {
      headerName: "TimeInCritsit",
      type: "number",
      field: "timeInCritsit",
      width: 150,
      sortable: true
    },
    {
      headerName: "TimeInCritsit1",
      type: "number",
      field: "timeInCritsit1",
      width: 150,
      sortable: true
    },
    {
      headerName: "TimeInCritsitA",
      type: "number",
      field: "timeInCritsitA",
      width: 150,
      sortable: true
    },
    {
      headerName: "Days To Close",
      type: "number",
      field: "daysToClose",
      width: 150,
      sortable: true
    },
    {
      headerName: "Is IRMet",
      field: "isIRMet",
      width: 150,
      sortable: true
    },
    {
      headerName: "Service Request Current Severity",
      field: "serviceRequestCurrentSeverity",
      width: 240,
      sortable: true
    },
    {
      headerName: "Service Request Max Severity",
      field: "serviceRequestMaxSeverity",
      width: 240,
      sortable: true
    },
    {
      headerName: "Reopen Count",
      type: "number",
      field: "reopenCount",
      width: 150,
      sortable: true
    },
    {
      headerName: "RelatedICM_Id",
      field: "relatedICM_Id",
      width: 150,
      sortable: true
    },
    {
      headerName: "PredictedL1Category",
      field: "predictedL1Category",
      width: 150,
      sortable: true
    },
    {
      headerName: "PredictedL2Category",
      field: "predictedL2Category",
      width: 150,
      sortable: true
    }
  ];

  React.useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
    }, 1000);
  }, []);

  return (
    <>
      {props.tableData && props.tableData.length > 0 ? (
        <div style={{ height: 600, width: "100%" }} tabIndex={0}>
          <CustomDataGrid
            columns={columns}
            enableUrlParams
            exportCsvButtonProps={{
              fileNamePrefix: "support-requests"
            }}
            getRowId={(row) => row.id}
            rows={{ values: props.tableData ?? [], count: props.tableData?.length ?? 0 }}
            showCellVerticalBorder
            sx={{
              "& .MuiDataGrid-columnHeaderDraggableContainer": {
                flexDirection: "inherit !important"
              },
              "& .MuiDataGrid-columnHeaderTitleContainer": {
                flexDirection: "inherit !important"
              },
              "& .MuiDataGrid-cell": {
                justifyContent: "flex-start",
                textAlign: "left"
              }
            }}
            kustoLink={props?.kustoLink}
            TabName={`Customer View - Support Table for ${props.tenantName}`}
          />
        </div>
      ) : (
        showNoData() || ""
      )}
    </>
  );
};

export default SupportTable;
